
<template>
  <div class="old-customer-box" v-if="showTemplateData">
    <!-- 沉浸式 -->
    <Immersion :title="$t('FoodC_C_Mission_Centre_HafM')" />
    <template v-if="taskData != null">
      <div class="data-container">
        <!-- banner -->
        <Banner :country="getCountry" />
        <div v-for="(item, index) of taskData" :key="index">
          <!-- 任务中心 -->
          <TaskCenter
            v-if="item.missionType == 1"
            :key="index"
            :taskData="item"
            :isOtherActivity="isOtherActivity"
            @_initData="_initData"
          />
          <OtherTask
            v-else-if="item.missionType == 2"
            :key="index"
            :taskData="item"
            @_initData="_initData"
          />
        </div>
      </div>
    </template>
    <div v-else-if="loading"></div>
    <template v-else-if="taskData == null">
      <NoTask />
    </template>
  </div>
</template>
<script>
import { isEmpty } from 'lodash-es'
import { getMissionAggregation } from '@/api/oldCustomer/index.js'
import loginMixin from '@/common/mixin/login'

import Immersion from '@/components/immersion/index.vue'
import Banner from './components/banner.vue'
import TaskCenter from './components/taskCenter.vue'
import OtherTask from './components/otherTask.vue'
import NoTask from './components/noTask.vue'
export default {
  mixins: [loginMixin],
  components: {
    Immersion,
    Banner,
    TaskCenter,
    OtherTask,
    NoTask
  },
  data () {
    return {
      taskData: null,
      loading: false,
      closeDialogStatus: false,
      showTemplateData: false
    }
  },
  computed: {
    // 获取对应的国家
    getCountry () {
      return this.$store.state.country
    },
    isOtherActivity () {
      // 是否有其他活动（目前只有Cgc即6）1 有 2 无
      if (!this.taskData) return 2
      return isEmpty(this.taskData.filter(item => item.missionType === 2)) ? 2 : 1
    }
  },
  created () {
    // 检测登录
    // this._initTemplateData()
    this.getTokenToLogin(this._initTemplateData)
  },
  methods: {
    _initTemplateData () {
      this.showTemplateData = true
      this._initData()
    },
    async _initData () {
      this.loading = true
      const res = await getMissionAggregation({
        isFocusNode: 1 // 0或者不传表示全部节点模式，1表示只有奖励节点模式. 若为1 会增加betweenNextFocusNode返回值
      })
      this.loading = false
      if (isEmpty(res.data)) {
        this.taskData = null
        return
      }
      if (!res.errno) {
        this.optimizationData(res.data)
      }
    },
    // 服务端不实时返回数据前端得特殊处理
    optimizationData (data) {
      this.taskData = data.map(item => {
        const list = item
        if (list.missionType === 1) {
            if (list.missionProgressReward.length == 1) { // eslint-disable-line
            // 1单的时候去除优惠券上的按钮
            list.missionProgressReward[0].rewardStrategy[0].buttons = []
          } else {
            // 如果不是一单的情况下,判断首单的节点是不是占位的节点，如果不是，增加一个占位空节点
              if (list.missionProgressReward[0].ladderNum != 0) {// eslint-disable-line
              const defaultNode = {
                'ladderNum': -1,
                'isCompleteMission': false,
                'isHasReward': false,
                'isReceiveReward': false
              }
              list.missionProgressReward.unshift(defaultNode)
            }
          }
        }
        return {
          ...list
        }
      }) || []
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "~@/common/stylus/variables"
.old-customer-box
  min-height 100%
  display flex
  flex-direction column
.data-container
  min-height 100%
  background-primary-color()
  padding-bottom 127px
  flex: 1
>>> .van-overlay
  background-color rgba(0,0,0,.4)
</style>
